import { render, staticRenderFns } from "./securityCenter.vue?vue&type=template&id=5af2511a"
import script from "./securityCenter.vue?vue&type=script&lang=js"
export * from "./securityCenter.vue?vue&type=script&lang=js"
import style0 from "./securityCenter.vue?vue&type=style&index=0&id=5af2511a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports